// import vue
import Vue from 'vue'

// import katex
import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css'

Vue.use(VueKatex)
